import { gql } from "@apollo/client";

const UserSubscription = gql`
  subscription UserSubscription {
    listen(topic: "users_update") {
      query {
        allUsers {
          nodes {
            id
            appId
            email
            firstName
            lastName
            isActive
            isAdmin
            isExternal
            joinedOn
            uploadsByUserId {
              totalCount
            }
          }
        }
      }
    }
  }
`;

const hash = "bf2d2b05f667c5aadbcf4113f626625011527228094f90881600f64793e04f0b";

export { UserSubscription, hash };
